module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Bold.fc1aba7d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Bold.woff
// module id = 2365
// module chunks = 50